// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 메뉴 칸은 머리(회사 이름)와 꼬리(로그아웃) 사이만 차지하고 넘치면 이 칸만 스크롤(로그아웃 칸과 겹치지 않음).
   맥 기본 스크롤 막대는 굴리기 전엔 안 보여 아래 메뉴(「내 계정 보안」·「2단계 인증」)가 없어진 것처럼 보임 →
   막대를 늘 보이게 그림(-webkit- 스타일을 주면 맥 Chrome·Safari 도 막대를 숨기지 않음) */
.sidenav-content[data-v-78e3fae8] {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 0;
}
.sidenav-content[data-v-78e3fae8]::-webkit-scrollbar {
  width: 6px;
}
.sidenav-content[data-v-78e3fae8]::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}
.sidenav-content[data-v-78e3fae8]::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
.sidenav-category[data-v-78e3fae8] {
  margin-bottom: 24px;
}
.sidenav-category-title[data-v-78e3fae8] {
  padding: 8px 24px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.4);
}
.sidenav-category-items[data-v-78e3fae8] {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
